import { Link } from "react-router-dom";
import { Facebook, Twitter, Linkedin, Instagram } from "lucide-react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <Link to="/" className="footer-logo">
              <img
                src="/logo.png"
                alt="ProSkillNest"
                className="footer-logo-image"
              />
            </Link>
          </div>

          <div className="footer-section">
            <h4>Menu</h4>
            <ul className="footer-links">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/contact">Contact Us</Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Legal</h4>
            <ul className="footer-links">
              <li>
                <Link to="/privacy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms">Terms & Conditions</Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Find Us On</h4>
            <div className="social-links">
              <button
                type="button"
                aria-label="Facebook"
                className="social-link-btn"
              >
                <Facebook size={20} />
              </button>
              <button
                type="button"
                aria-label="Twitter"
                className="social-link-btn"
              >
                <Twitter size={20} />
              </button>
              <button
                type="button"
                aria-label="LinkedIn"
                className="social-link-btn"
              >
                <Linkedin size={20} />
              </button>
              <button
                type="button"
                aria-label="Instagram"
                className="social-link-btn"
              >
                <Instagram size={20} />
              </button>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>
              &copy; {new Date().getFullYear()} ProSkillNest. All rights
              reserved.
            </p>
          </div>
          <div className="footer-legal-links">
            <Link to="/privacy">Privacy Policy</Link>
            <span className="separator">•</span>
            <Link to="/terms">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
